import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export class SurveyQuestion implements IIndexable {
  id: number;

  question: {
    id: number;
    prompt: string;
    question_type: string;
    response_required: boolean;
  };

  choices: [
    {
      id: number;
      text: string;
    }
  ];

  completion_factor: number;
  answer_choices: number[];
  free_text_answer: string;

  constructor(surveyQuestion: Partial<SurveyQuestion>) {
    _4.merge(this, surveyQuestion);
  }

  static build(surveyQuestion: Partial<SurveyQuestion>): SurveyQuestion {
    return new SurveyQuestion(surveyQuestion);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/builders/survey_question_builder.ts